export default __webpack_public_path__ + "static/exp5-3d67bb6648614b423be234ed42b0b698.webp";